<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
  <div class="d-flex flex-wrap" *ngIf="token">
    <div class="two-card common-padding pay-money shadow">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
      &nbsp;
      <h2 class="heading">International Gift Voucher</h2>
      <div class="row no-gutters">
        <div class="col-12">
          <div class="row no-gutters">
            <div class="col-md-12">
              <div class="add-balance">
                <div class="ctl-inner">
                  <span class="crtl icon-add_money_1"></span>
                </div>
                <div>
                  <span class="bal-txt">Balance</span>
                  <span class="bal_amount">{{UsertBal.currentBalance}} {{UsertBal.currency}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-12 form-padding">
              <form class="example-form" [formGroup]="payDTHMoneyForm" (ngSubmit)="openDialog(payDTHMoneyForm.value)">


                <div class="row no-gutters">
                  <div class="col-12">
                    <mat-radio-group class="example-radio-group" formControlName="PaymentModeCode">
                      <mat-radio-button *ngFor="let x of OptionList?.addmoneyservice" [value]="x.code">{{x.name}}</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div class="col-12">
                    <mat-form-field>
                      <mat-label>Select Country</mat-label>
                      <mat-select formControlName="ISD" matTooltip="Select Country" autocomplete="off"
                                  required>
                        <mat-form-field>
                          <input matInput [formControl]="CountryFilterCtrl" placeholder="Search Country" />
                        </mat-form-field>
                        <mat-option *ngFor="let d of filterCountry(); let i=index" [value]="d.country_id" (click)="selectservicebycountry_id(d?.country)">
                          {{d?.country}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && f.ISD?.errors?.required">
                        Select Country
                      </mat-error>
                    </mat-form-field>

                  </div>
                  <div class="col-12" *ngIf="IsDataGet">
                    <mat-form-field>

                      <mat-label>Select Service Name</mat-label>
                      <mat-select formControlName="service_id" (selectionChange)="service_id()" required>
                        <mat-option [value]="d.service_id"
                                    *ngFor="let d of serviceList; let i=index">
                          {{d?.service}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && f.service_id?.errors?.required">
                        Select Service Name
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-12" *ngIf="IsOprtDataGet">
                    <mat-form-field>

                      <mat-label>Select Operator</mat-label>
                      <mat-select formControlName="operator_id" required>
                        <mat-option [value]="d.operator_id"
                                    *ngFor="let d of operatorList; let i=index" (click)="operator_id(d?.operator)">
                          <img matSuffix [src]="d?.imageUrl"
                               style="height: 20px;width: 20px;" />
                          {{d?.operator}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && f.operator_id?.errors?.required">
                        Select Operator
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-12" *ngIf="isGetproductList">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Account Number (eg:02444786698)"
                             formControlName="account_number" NumberOnly minlength="8" maxlength="10"
                             required>
                      <mat-error *ngIf="submitted && f.account_number?.errors?.required">
                        Account Number is required
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-12">
                    <mat-form-field *ngIf="isGetproductList">
                      <mat-label>Select Product</mat-label>

                      <mat-select formControlName="Amount"
                                  (selectionChange)="selectedProduct($event)" required>
                        <mat-option [value]="d.value" *ngFor="let d of productList; let i=index">
                          {{d?.text}}
                        </mat-option>

                      </mat-select>
                      <mat-error *ngIf="submitted && f.Amount?.errors?.required">
                        Amount is required
                      </mat-error>
                    </mat-form-field>
                    <div class="row payable-amount justify-content-around align-items-center mb-4 mt-0">
                      <div class="col-6" *ngIf="amt">

                        <p *ngIf="UsertBal.currency == 'USD' && show == 1 || show == 3"><b>Fee({{UsertBal.currency}})</b></p>
                        <p *ngIf="UsertBal.currency == 'USD' && show == 1 || show == 3">{{commissionFee|number}}
                      </div>
                      <div class="col-6 text-right" *ngIf="amt">
                        <p *ngIf="UsertBal.currency == 'USD' && show == 2"><b>Net Amount In USD</b></p>
                        <p *ngIf="UsertBal.currency == 'USD' && show == 1 || show == 3">Net Payable({{UsertBal.currency}})</p>
                        <p *ngIf="amt">{{commissionTotal|number}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Beneficiary Name"
                             formControlName="BeneficiaryName" maxlength="20" />
                      <mat-error *ngIf="f.BeneficiaryName?.errors?.pattern">
                        Enter Alphabet character
                      </mat-error>

                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Optional Description" formControlName="Comment"
                             maxlength="200" />

                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <button type="submit" class="primary-btn">
                      SUBMIT
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12 mt-4">
          <div class="pay-detail text-center">
            <div class="icon_wrap">
              <i class="icon-payment_secure"></i>
            </div>
            <span class="ng-binding">Your payment details are secured</span>
          </div>
        </div>
      </div>
    </div>
    <div class="two-card recent-card common-padding pay-money shadow overflow-auto">
      <h2 class="heading recent-head">Recent Transaction</h2>
      <table class="table table-hover text-center  table-bordered">
        <thead>
          <tr>
            <th>Service Name</th>

            <th>Mobile No.</th>
            <th>Amount</th>
            <th>Transaction Status</th>
          </tr>
        </thead>

        <tbody *ngFor="let x of userorderdetailList; let i=index">
          <tr *ngIf="i<10">
            <td>
              {{x.serviceName}}
            </td>

            <td>{{x.destination}}</td>
            <td>{{x.amount}}</td>
            <td>{{x.transactionRemark}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</fieldset>
